var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/path.js
// module id = 96
// module chunks = 48